import { useState, useEffect, useMemo } from 'react'
import { TitleText, ProtocolNotification, Deadline, EmptyNotification } from './styles'
import { Pagination } from 'components/Pagination'
import CountdownNotification from 'components/Countdown';
import { calculateTimeLeft, DAMAGE_LEVELS, getDateTime, getWarningCountdownColor } from 'utils/damage';
import { NavItems } from 'pages/Notifications/Nav';
import { OutlinePersonIcon } from 'components/Icons/OutlinePersonIcon';
import OutlineCheckIcon from 'components/Icons/OutlineCheckIcon';
import { notificationStatus } from 'constants/notificationStatus';
import { MdOutlineInventory2 } from 'react-icons/md';
import { NotificationType } from 'types/notification';
import sectorIcon from '../../../assets/icons/sector.svg'
import { emptyNotificationsText, notificationAnalizer } from './helpers';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { VariableReducer } from 'types/variable';
import { RootReducerState } from 'types/global';
import { variableListNumberPatientsInvolved } from 'pages/NotificationTreatment/NotificationsTreatmentsSteps/NotificationData/helper';
import { featureFlags } from 'config/featureFlags';
import { findNavbarItemBySubState, NotificationSubStatus } from 'constants/notificationSubState';

interface RightSide {
  notificationsList: NotificationType[]
  navItem: any
  paginationItensByPage: any
  paginationNumberSelectedPage: any
  setSelectedNotification: any
  currentNav: NavItems,
  damageLevelList: any[]
  currentNotificationSelected: any
  setNotificationsList: any,
  highlightText?: (s: string) => void
  handleShowGroupTreatmentModal?: (groupCount: number) => void
  userProfile?: string
  subState?: string
  notificationScreen?: any
}
const RightSide = ({ notificationsList,
  navItem,
  paginationItensByPage,
  paginationNumberSelectedPage,
  setSelectedNotification,
  currentNav,
  damageLevelList,
  currentNotificationSelected,
  setNotificationsList,
  highlightText,
  handleShowGroupTreatmentModal,
  userProfile,
  subState,
  notificationScreen
}: RightSide) => {
  const navigate = useNavigate()

  const variableSelector: VariableReducer = useSelector(
    (state: RootReducerState) => state.variableReducers
  )

  const [listNotifications, setListNotifications] = useState<any>([])
  const [damageLevel, setDamageLevel] = useState<any[]>([])

  const getDamageColor = (tipo: string) => {
    return tipo.toLowerCase().replace(' ', '-')
  }

  const getDamage = (damage) => {
    return DAMAGE_LEVELS.find(d => d.id === damage);
  }

  const isNotWarningHighDamage = (damage) => {
    if (damage === "0" || damage.length < 32) return true;
    let damageValue = getDamage(damage)?.value;
    return damageValue === 'near-miss' || damageValue === 'notifiable';
  }

  const haveMultiplier = (notification: any) => {
    if (
      notification?.u_number_patients_involved?.value ===
      variableListNumberPatientsInvolved(variableSelector)
        ?.choices?.[2]?.value &&
      notification?.involves_patient?.value &&
      notification?.u_notification_multiplier?.value
    ) {
      return true
    }
  }

  useEffect(() => {
    setDamageLevel(damageLevelList)
  }, [damageLevelList])

  useEffect(() => {

    setListNotifications(notificationsList)
  }, [notificationsList])


  return (
    <div className="flex flex-col col-span-2">
      <div className='container overflow-y-auto custom-scrollbar-larger'>
        {listNotifications?.length === 0 ? (
          <div className='h-[696px]'>
            <EmptyNotification className='content-center	'> {emptyNotificationsText(navItem)} </EmptyNotification>
          </div>
        ) : (
          <div className='h-[696px]'>
            {listNotifications && listNotifications.map((item, index) => (
              <div onDoubleClick={() => notificationAnalizer(currentNotificationSelected, notificationsList, setNotificationsList, navigate, featureFlags.groupNotifications ? handleShowGroupTreatmentModal : undefined, userProfile)} key={index} onClick={() => setSelectedNotification(index)} className={`flex flex-row border-solid border-[1px] cursor-pointer border-x-gray-100 h-30 ${item.selected ? 'bg-[#EEEEF4]/80' : 'hover:bg-[#EEEEF4]/80'}`} >
                {item.u_notification_read?.value === 'false' && item.u_state?.value === '1' ? (
                  <div className='mt-px"]'>
                    <svg width="4" height="110" viewBox="0 0 4 110" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="4" height="110" fill={"#F0B323"} />
                    </svg>
                  </div>
                ) : (<></>)}

                <div className="basis-5/6 mt-3 mb-2">
                  <div className="align-middle flex flex-row ml-2 max-w-full">
                    {item.u_notification_read?.value === 'false' && item.u_state?.value === '1' ? (
                      <div className='mt-3 mr-2'>
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="8" height="8" rx="4" fill={"#F0B323"} />
                        </svg>
                      </div>
                    ) : (<div className='mt-3 mr-4'></div>)}

                    <div className='mt-1 max-w-full'>
                      <TitleText>{highlightText ? highlightText(item.incident_title.display_value) : item.incident_title.display_value}</TitleText>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 mt-3 ml-6">
                    {item.damage_level?.value !== "0" && item.damage_level?.value.length === 32 ? (
                      <span className={isNotWarningHighDamage(item.damage_level?.value) ?
                        ('text-[#474747] text-[12px] italic font-medium')
                        : (`chip-incidente incidente-${getDamageColor(getDamage(item.damage_level?.value)?.value)} `)}>
                        {`${getDamage(item.damage_level?.value).label}`}
                      </span>
                    ) : (
                      <span />
                    )}

                    {featureFlags.groupNotifications && item.eligible_for_group_treatment && (!item?.u_treatment_group?.value || item?.u_treatment_group?.value === '') && (
                      <span className='text-darkGray text-[10px] bg-[#E5E5E5] px-2 rounded-[14px] flex h-full items-center gap-1 max-h-[18px]'>
                        Disponível para tratamento em grupo
                      </span>
                    )}

                    {featureFlags.groupNotifications && item.u_state?.value == 3 && item?.u_treatment_group?.display_value && (
                      <span className='text-darkGray text-[10px] bg-[#E5E5E5] px-2 rounded-[14px] flex h-full items-center gap-1 max-h-[18px]'>
                        Tratamento em grupo {item?.u_treatment_group.display_value}
                      </span>
                    )}

                    {featureFlags.groupNotifications && item.u_state?.value == 5 && item?.u_treatment_group?.display_value && (
                      <span className='text-darkGray text-[10px] bg-[#E5E5E5] px-2 rounded-[14px] flex h-full items-center gap-1 max-h-[18px]'>
                        Tratada em grupo {item?.u_treatment_group.display_value}
                      </span>
                    )}

                    {haveMultiplier(item) &&
                      <span className='text-darkGray text-[10px] bg-[#E5E5E5] px-2 rounded-[14px] flex h-full items-center gap-1 max-h-[18px]'>
                        <span>
                          Notificação em massa {' '}
                        </span>
                        <span className='text-xs font-semibold'>
                          x {item?.u_notification_multiplier.value}
                        </span>
                      </span>}

                    {item.u_reopening_date?.value && (
                      <span className='text-darkGray text-[10px] bg-[#E5E5E5] px-2 rounded-[14px] flex h-full items-center gap-1 max-h-[18px]'>
                        Reaberta
                      </span>
                    )}
                  </div>

                  <div className="justify-center ml-6 mt-1">
                    <span className="header-notificacao-preview">
                      {locationName(item)}
                    </span>
                  </div>
                  <NotificationAssignedTo currentNav={currentNav} item={item} />

                </div>

                <div className="basis-1/6 mt-[18px] mr-[20px]">

                  <CountdownNotification
                    notification={item}
                    status={item?.u_state?.value}
                    color={`${getWarningCountdownColor(item)}`}
                    timer={`${calculateTimeLeft(item)}`} />

                  <ProtocolNotification>
                    {highlightText ? highlightText(item?.number?.display_value) : item?.number?.display_value}
                  </ProtocolNotification>

                  <Deadline className='header-notificacao-preview'>
                    {item?.sys_created_on?.display_value?.substring(0, item?.sys_created_on?.display_value.length - 3)}
                  </Deadline>

                  <ShowStatus currentNav={currentNav} item={item} />

                </div>
              </div>
            ))}
          </div>
        )}

      </div>
      <div className='mt-5 mr-2  ml-1 mb-3 w-auto content-end'>
        <Pagination
          paginationTotal={(() => {
            // Se estiver na aba de Finalizados (id 5) e houver filtro de subState,
            // buscar o contador correto do backend usando o u_sub_state
            if (currentNav?.id === 5 && subState && subState !== '' && notificationScreen?.navbar) {
              const finishedNavItem = findNavbarItemBySubState(notificationScreen.navbar, 5, subState)
              
              if (finishedNavItem && finishedNavItem.number !== undefined) {
                const total = parseInt(finishedNavItem.number) || 0
                return total
              }
              
              // Se não encontrou, pode ser que o backend não retornou o item com u_sub_state
              // Nesse caso, verificar se há um item na navbar com o u_sub_state correto
              const allFinalizedItems = notificationScreen.navbar.filter((item: any) => item && item.id === 5)
              
              const itemWithSubState = allFinalizedItems.find((item: any) => {
                if (!item?.u_sub_state) return false
                const sub_state = subState === 'u_finalizada_com_tratativa' ? 'u_finalizada_com_tratativa' : 
                                 subState === 'u_finalizada_sem_tratativa' ? 'u_finalizada_sem_tratativa' : null
                return item.u_sub_state === sub_state
              })
              
              if (itemWithSubState && itemWithSubState.number !== undefined) {
                const total = parseInt(itemWithSubState.number) || 0
                return total
              }
              
              // Se não encontrou nenhum item com o u_sub_state, retornar 0
              // (porque o filtro foi aplicado mas não há itens correspondentes)
              return 0
            }
            
            // Se currentNav tem número e está na aba de Finalizados SEM filtro, usar o número do currentNav
            if (currentNav?.id === 5 && (!subState || subState === '') && currentNav?.number) {
              const total = parseInt(currentNav.number) || 0
              return total
            }
            
            // Caso padrão: usar o número do navItem
            const total = navItem ? parseInt(navItem.number) || 0 : 0
            return total
          })()}
          paginationItensByPage={paginationItensByPage}
          paginationNumberSelectedPage={paginationNumberSelectedPage}
          tableSize={listNotifications?.length} />
      </div>
    </div>

  )
}

export default RightSide

export const canRenderNotifcationAssignedUserStatusIds = [notificationStatus[2]?.value, notificationStatus[3]?.value, notificationStatus[4]?.value, notificationStatus[5]?.value]
export const showSector = [notificationStatus[1]?.value]
const locationName = (item: any) => {
  let textToShow: string = item?.location_incident?.display_value
  if (!showSector.includes(item.u_state?.value)) {
    textToShow = textToShow?.concat('/ ')?.concat(item?.incident_sector?.display_value)
  }
  return textToShow
}

export const NotificationAssignedTo = ({ currentNav, item }: { currentNav: NavItems, item: any }) => {
  if (showSector.includes(item.u_state?.value)) {
    return (
      <div className="flex gap-1 ml-6 mt-1" data-testid="test-assigned-to-component">
        <img
          src={sectorIcon}
          alt="logos"
          width={20}
        />
        <span className="text-amberAlt text-xs font-semibold">
          {item?.incident_sector?.display_value}
        </span>
      </div>
    )
  } else {
    if (!canRenderNotifcationAssignedUserStatusIds.includes(item.u_state?.value)) {
      return null
    }
    return (
      <div className="flex gap-1 ml-6 mt-1" data-testid="test-assigned-to-component">
        <OutlinePersonIcon width='15' height='15' color='#893367' />
        <span className="text-roxo text-xs font-semibold">
          {item?.u_assigned_to?.display_value}
        </span>
      </div>
    )
  }

}
export const cannotRenderNotifcationClosedTimeStatusIds = [notificationStatus[0]?.value]
export const ShowStatus = ({ currentNav, item }: { currentNav: NavItems, item: any }) => {
  const dataByStatus = useMemo(() => {
    if (item.u_state?.value === notificationStatus[4]?.value) {
      // Determina o texto baseado no u_sub_state
      let finalizationText = 'Finalizada em'
      const subStateValue = item.u_sub_state?.value || item.u_sub_state
      
      if (subStateValue === NotificationSubStatus.FINALIZADA_COM_TRATATIVA) {
        finalizationText = 'Finalizada com tratativa em'
      } else if (subStateValue === NotificationSubStatus.FINALIZADA_SEM_TRATATIVA) {
        finalizationText = 'Finalizada sem tratativa em'
      }
      
      return {
        color: '#5FD290',
        textColor: 'text-[#5FD290]',
        text: finalizationText,
        step: notificationStatus[4]?.value,
        showDate: true
      }
    } else if (item.u_state?.value === notificationStatus[5]?.value) {
      return {
        color: '#DF8D2C',
        textColor: 'text-[#DF8D2C]',
        text: 'Arquivada em',
        step: notificationStatus[5]?.value,
        showDate: true
      }
    } else if (item.u_state?.value === notificationStatus[1]?.value
      || item.u_state?.value === notificationStatus[2]?.value
      || item.u_state?.value === notificationStatus[3]?.value) {
      const baseStatus = notificationStatus.find(s => s.value === item.u_state?.value).label
      const isReopened = item.u_reopening_date?.value
      
      return {
        color: '#828282',
        textColor: 'text-[#828282]',
        text: baseStatus,
        showDate: false,
        isReopened: isReopened
      }
    }
  }, [item.u_state, item.u_sub_state])


  if (cannotRenderNotifcationClosedTimeStatusIds.includes(item.u_state?.value)) {
    return null
  }
  return (<div className="flex justify-end gap-1 my-1 w-[350px]" data-testid="test-show_when_closed_component">
    {dataByStatus?.showDate ? (
      <>
        {
          dataByStatus.step === notificationStatus[5]?.value ?
            <MdOutlineInventory2 width='15' height='15' color={dataByStatus?.color} />
            : <OutlineCheckIcon width='15' height='15' color={dataByStatus?.color} />
        }
        <span className={`${dataByStatus?.textColor} text-xs font-bold`}>
          {`${dataByStatus?.text} `}{getDateTime(item?.u_date_and_hour_notification_closed?.value)}
        </span>
      </>
    )
      :
      <div className="flex flex-col items-end gap-1">
        <span className={`${dataByStatus?.textColor} text-xs font-bold`}>
          {`${dataByStatus?.text}`}
        </span>
      </div>
    }
  </div>)

}